import { Box, Chip, Tooltip, Typography } from "@mui/material";

// Read-only counterpart to ManagedByCell: the people this row manages
// (models/user.js#manageUsers). Editing lives in the Manage dialog's "Manages these users"
// picker — this column is just so the hierarchy is visible at a glance without opening
// every row.
const MAX_VISIBLE = 1;

const CHIP_SX = { fontFamily: "Quicksand", fontWeight: 700, fontSize: 11 };

export default function ManagesCell({ user }) {
  const manages = user.manageUsers || [];

  if (!manages.length) {
    return (
      <Typography sx={{ fontFamily: "Quicksand", fontWeight: 600, fontSize: 13, color: "#9CA3AF" }}>
        —
      </Typography>
    );
  }

  // A handful of people manage 9-11 others — showing every chip would blow the row height
  // out, so the rest collapse into a "+N" the full list hangs off of.
  const visible = manages.slice(0, MAX_VISIBLE);
  const overflow = manages.slice(MAX_VISIBLE);

  return (
    <Box sx={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: 0.5 }}>
      {visible.map((person) => (
        <Chip key={person.id} size="small" label={person.fullName} sx={CHIP_SX} />
      ))}

      {overflow.length > 0 && (
        <Tooltip title={overflow.map((person) => person.fullName).join(", ")}>
          <Chip
            size="small"
            label={`+${overflow.length}`}
            sx={{ ...CHIP_SX, bgcolor: "rgba(255,82,0,0.10)", color: "#FF5200" }}
          />
        </Tooltip>
      )}
    </Box>
  );
}
